var _path, _path2, _rect, _rect2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 64,
    viewBox: "0 0 60 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 30C34.6024 30 38.3333 26.409 38.3333 21.9792C38.3333 17.5494 34.6024 13.9583 30 13.9583C25.3976 13.9583 21.6667 17.5494 21.6667 21.9792C21.6667 26.409 25.3976 30 30 30ZM30 26.7917C27.2386 26.7917 25 24.637 25 21.9792C25 19.3213 27.2386 17.1667 30 17.1667C32.7614 17.1667 35 19.3213 35 21.9792C35 24.637 32.7614 26.7917 30 26.7917Z",
    fill: "#1C4A76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8381 33.0752C40.4341 31.8425 38.2616 31.5766 36.5269 32.4773C36.2095 32.6421 35.9302 32.7929 35.6727 32.9319C34.9894 33.3009 34.4592 33.5872 33.7756 33.833C32.9167 34.1418 31.8058 34.375 30 34.375C28.2114 34.375 27.0821 34.1549 26.2102 33.8569C25.4392 33.5934 24.8304 33.2623 24.0281 32.826C23.8716 32.741 23.7075 32.6517 23.5337 32.5583C21.7931 31.6235 19.5577 31.8407 18.1069 33.1236C17.4741 33.6832 16.7339 34.407 16.1415 35.1955C15.5767 35.9473 15 36.9472 15 38.0209V41.6671C15 44.0837 17.2389 46.0417 20 46.0417H40C42.7611 46.0417 45 44.0837 45 41.6671V38.0209C45 36.933 44.4079 35.9197 43.8326 35.1612C43.2283 34.3644 42.4753 33.6346 41.8381 33.0752ZM38.2279 34.9856C38.6265 34.7786 39.13 34.8294 39.4771 35.1341C40.0357 35.6245 40.6207 36.201 41.0552 36.774C41.5189 37.3852 41.6667 37.805 41.6667 38.0209V41.6671C41.6667 42.4723 40.9208 43.125 40 43.125H20C19.0792 43.125 18.3333 42.4723 18.3333 41.6671V38.0209C18.3333 37.8093 18.4758 37.3981 18.9269 36.7977C19.3503 36.2341 19.9226 35.6647 20.4763 35.1751C20.8235 34.8681 21.3518 34.8088 21.7898 35.044C21.9277 35.1181 22.0681 35.1948 22.2116 35.2732C23.0156 35.7124 23.9153 36.2038 24.9973 36.5736C26.3217 37.0264 27.8736 37.2917 30 37.2917C32.167 37.2917 33.7188 37.0067 35.0424 36.5308C36.001 36.1862 36.8466 35.7286 37.5931 35.3246C37.8132 35.2056 38.0246 35.0911 38.2279 34.9856Z",
    fill: "#1C4A76"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 57,
    height: 57,
    rx: 28.5,
    stroke: "#1C4A76",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 40,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#59D939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8398 49.3683C51.1238 49.0843 51.5843 49.0843 51.8683 49.3683C52.1523 49.6523 52.1523 50.1128 51.8683 50.3968L48.0394 54.2249C47.3302 54.9339 46.1808 54.9348 45.4704 54.2269L44.1506 52.9116C43.8666 52.6276 43.8666 52.1671 44.1506 51.8831C44.4346 51.5991 44.8951 51.5991 45.1791 51.8831L46.2378 52.9418C46.5218 53.2258 46.9823 53.2258 47.2663 52.9418L50.8398 49.3683Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 60C52.4183 60 56 56.4183 56 52C56 47.5817 52.4183 44 48 44C43.5817 44 40 47.5817 40 52C40 56.4183 43.5817 60 48 60ZM48 58.5405C44.3878 58.5405 41.4595 55.6122 41.4595 52C41.4595 48.3878 44.3878 45.4595 48 45.4595C51.6122 45.4595 54.5405 48.3878 54.5405 52C54.5405 55.6122 51.6122 58.5405 48 58.5405Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSuccess);
export default __webpack_public_path__ + "static/media/user-success.a1ee5726fdcbb2b641dfab7bd95b4387.svg";
export { ForwardRef as ReactComponent };